import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as moment from "moment";
import "moment-timezone";
import {
  deleteUserById,
  travellerList,
  userList,
} from "../../../services/userservice";
import {
  setLoading as setUserLoading,
  setUsers,
  deleteUser,
  setError,
} from "../../../features/common/travellerSlice";
import { Modal, Button } from "react-bootstrap";
import { sendWhatsappNotifications } from "../../../services/userservice";

const Traveller = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [usersPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const [rewardFilter, setRewardFilter] = useState("");
  const { users, loading, error } = useSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);
  const [showMailModal, setShowMailModal] = useState(false);
  const [selectedUserId, setUserId] = useState(null);
  const handleCloseModal = () => setShowModal(false);
  const [copied, setCopied] = useState(false);
  const [copiedUserId, setCopiedUserId] = useState(null);
  const navigate = useNavigate();


  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(setUserLoading());
        const response = await travellerList();
        dispatch(setUsers(response));
      } catch (error) {
        dispatch(setError(error.message));
      }
    };
    fetchData();
  }, [dispatch]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // const filteredUsers = users.filter(
  //   (user) =>
  //     user?.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     user?.phone_no?.includes(searchTerm.toLowerCase())
      
  // );
  const filteredUsers = users.filter((user) => {
    const matchesSearch =
      user?.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.phone_no?.includes(searchTerm.toLowerCase());
  
    const matchesReward =
      rewardFilter === ""
        ? true
        : rewardFilter === "yes"
        ? user?.reward_point > 0
        : user?.reward_point == 0;
  
    return matchesSearch && matchesReward;
  });

  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);

  const renderPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 3;

    if (totalPages <= 10) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first 3 pages
      pages.push(1, 2, 3);

      // Show "..." if currentPage is beyond 5
      if (currentPage > 5) {
        pages.push("...");
      }

      // Show current page and neighbors
      const start = Math.max(4, currentPage - 1);
      const end = Math.min(totalPages - 3, currentPage + 1);

      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) pages.push(i);
      }

      // Show "..." if currentPage is far from end
      if (currentPage < totalPages - 4) {
        pages.push("...");
      }

      // Always show last 3 pages
      pages.push(totalPages - 2, totalPages - 1, totalPages);
    }

    return pages.map((page, index) => (
      <li
        key={index}
        className={`page-item ${page === currentPage ? "active" : ""} ${
          page === "..." ? "disabled" : ""
        }`}
      >
        {page === "..." ? (
          <span className="page-link">...</span>
        ) : (
          <button className="page-link" onClick={() => setCurrentPage(page)}>
            {page}
          </button>
        )}
      </li>
    ));
  };

   const handleSendMail = async (id) => {
      try {
       console.log("id",id)
        const response = await sendWhatsappNotifications(id);
        if (response.data) {
          setShowMailModal(true);
          setShowModal(false);
          setTimeout(() => {
            navigate("/guest-list");
            setShowMailModal(false);
            setShowModal(false);
          }, 2000);
        }
  
        // alert(response.data);
      } catch (error) {
        console.error("Error sending email:", error);
        alert("Failed to send Notification");
      }
    };
    const openModal = (userId) => {
        setUserId(userId);
        setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const copyUrl = (id) => {
    const url = "https://superbworldtrip.com/create-profile";

    navigator.clipboard.writeText(url).then(() => {
    setCopiedUserId(id);

    setTimeout(() => {
      setCopiedUserId(null);
      }, 10000);
    });
  };


  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Users List</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-md-flex align-items-end  justify-content-end">
                    {/* <Link
                      to="/add-user"
                      className="btn btn-primary mb-md-0 mb-2 py-1 mr-3"
                    >
                      <i className="fas fa-plus" /> Add User
                    </Link> */}
                    <div className="card-tools">
                      <div
                        className="input-group input-group-sm"
                        style={{ width: "250px" }}
                      >
                        <input
                          type="text"
                          name="table_search"
                          className="form-control float-right"
                          placeholder="Search"
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <div className="input-group-append">
                          <button type="submit" className="btn btn-default">
                            <i className="fas fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label>Reward Point</label>
                      <br />
                      <select
                        className="form-control"
                        value={rewardFilter}
                        onChange={(e) => setRewardFilter(e.target.value)}
                      >
                        <option value="">Select Reward  Point</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                       
                      </select>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <label className="me-2">Show</label>
                      <select
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value));
                          setCurrentPage(1); // Reset to first page
                        }}
                        className="form-control mx-2 form-select d-inline-block w-auto"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ms-2">entries</span>
                    </div>
                    <div>
                      {/* Optional: Add search or pagination controls here */}
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "5%" }}>#</th>
                          <th style={{ width: "20%" }}>Name</th>
                          <th style={{ width: "20%" }}>Email</th>
                          <th style={{ width: "15%" }}>Phone Number</th>
                          <th style={{ width: "15%" }}>User Type</th>
                          <th style={{ width: "15%" }}>Reward Point</th>
                          <th style={{ width: "15%" }}>Expiry Date</th>
                          <th style={{ width: "15%" }}>Profile</th>
                          <th style={{ width: "10%" }}>Status</th>
                          <th style={{ width: "15%" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers.map((user) => (
                          <tr key={user?.id}>
                            <td>{user?.id}</td>
                            <td>{user?.firstName}</td>
                            <td>{user?.email}</td>
                            <td>{user?.phone_no}</td>
                            <td>{user?.user_type}</td>
                            <td>{user?.reward_point}</td>
                            <td>{user?.expiry_date}</td>
                            <td>{user?.isProfile ? 'Yes' : 'No'}</td>
                            <td>
                              <span
                                className={`badge p-2 w-100 ${
                                  user?.status === "active"
                                    ? "badge-success"
                                    : "badge-danger"
                                }`}
                              >
                                {user?.status?.toUpperCase()}
                              </span>
                            </td>
                            <td>
                              <div
                                className="d-flex align-items-center"
                                style={{ gap: "10px" }}
                              >
                                <Link to={`/edit/${user.id}`}>
                                  <button className="btn btn-primary btn-sm">
                                    Edit
                                  </button>
                                </Link>
                                 <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => openModal(user?.id)}
                                    //  onClick={() => handleSendMail(booking.id)}
                                  >
                                    <i className="fa fa-envelope"></i>
                                  </button>
                                 <button
                                    className={`btn btn-sm d-flex align-items-center ${
                                      copiedUserId === user?.id ? "btn-success" : "btn-outline-primary"
                                    }`}
                                    style={{
                                      transition: "all 0.3s ease",
                                      gap: "5px",
                                    }}
                                    onClick={() => copyUrl(user?.id)}
                                  >
                                    {copiedUserId === user?.id ? (
                                      <>
                                        <i className="fa fa-check"></i> Copied!
                                      </>
                                    ) : (
                                      <>
                                        <i className="fa fa-copy"></i> Copy URL
                                      </>
                                    )}
                                  </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-md-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {indexOfFirstUser + 1} to{" "}
                      {Math.min(indexOfLastUser, filteredUsers.length)} of{" "}
                      {filteredUsers.length} entries
                    </div>
                    <nav>
                      <ul className="pagination mb-0">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage - 1)}
                          >
                            Previous
                          </button>
                        </li>

                        {renderPageNumbers()}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal show={showMailModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>
                  <i className="fa fa-check-circle text-success"></i>
                  Success
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="text-center">
                  <i
                    className="fa fa-check-circle text-success mb-4"
                    style={{ fontSize: "4rem" }}
                  ></i>
                  <h4>Profile Link has been successfully sent!</h4>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
      
            <Modal show={showModal} onHide={closeModal}>
              <Modal.Header closeButton>
                <Modal.Title>Confirm</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="text-center p-4">
                  <h5>Are you sure you want to send this Notification?</h5>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-secondary" onClick={closeModal}>
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => handleSendMail(selectedUserId)}
                >
                  OK
                </button>
              </Modal.Footer>
            </Modal>
    </div>
  );
};

export default Traveller;
